import { gql } from "@apollo/client";

export const FETCH_ALC_B2C_STOCK = gql`
  query FETCH_ALC_B2C_STOCK {
    alcB2cStock
  }
`;

export const FETCH_SHOPIFY_ALC_ORDERS = gql`
  query FETCH_SHOPIFY_ALC_ORDERS($source: String!) {
    latestShopifyOrder(source: $source) {
      gid
      name
      adminUrl
    }
    shopifyShopOrders(source: $source) {
      id
      gid
      name
      adminUrl
      soName
      csv
    }
  }
`;

export const FETCH_ALC_CSV_PREVIEW = gql`
  query FETCH_ALC_CSV_PREVIEW($csv: String!, $limit: Int) {
    alcCsvPreview(csv: $csv, limit: $limit)
  }
`;

export const FETCH_ALC_INCOMING_XML_FILES = gql`
  query FETCH_ALC_INCOMING_XML_FILES {
    alcIncomingXmlFiles {
      name
      createdAt
    }
  }
`;

export const FETCH_ALC_XML_PREVIEW = gql`
  query FETCH_ALC_XML_PREVIEW($xml: String!, $limit: Int) {
    alcXmlPreview(xml: $xml, limit: $limit)
  }
`;

export const FETCH_ALC_XML_DOWNLOAD = gql`
  query FETCH_ALC_XML_DOWNLOAD($xml: String!) {
    alcXmlDownload(xml: $xml)
  }
`;
